import React from "react";
import About from "../sections/About";
import Testimonials from "../sections/Testimonials";
import CtaBand from "../sections/CtaBand";
import SEO from "../components/SEO";
import { useI18n } from "../i18n/I18nProvider";
import { getSiteOrigin } from "../siteOrigin";

export default function StudioPage() {
  const { lang } = useI18n();
  const SITE = getSiteOrigin();

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "@id": `${SITE}/studio#about`,
      url: `${SITE}/studio`,
      inLanguage: lang === "fr" ? "fr-CA" : "en-CA",
      name: lang === "fr" ? "À propos — Phaneroo Prod" : "About — Phaneroo Prod",
      description: lang === "fr"
        ? "Studio bilingue de production cinématographique basé à Moncton, NB. Films de marque, photographie éditoriale, drone aérien et contenu social partout au Canada Atlantique."
        : "Bilingual cinematic production studio based in Moncton, NB. Brand films, editorial photography, drone aerial and social content across Atlantic Canada.",
      mainEntity: { "@id": `${SITE}/#studio` },
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: lang === "fr" ? "Accueil" : "Home", item: `${SITE}/` },
        { "@type": "ListItem", position: 2, name: lang === "fr" ? "Studio" : "Studio", item: `${SITE}/studio` },
      ],
    },
  ];

  return (
    <main className="pt-32 bg-[#050505]" data-testid="page-studio">
      <SEO
        title={lang === "fr"
          ? "Studio Moncton — Production cinématique bilingue | À propos"
          : "Moncton Cinematic Studio — Bilingual Production | About"}
        description={lang === "fr"
          ? "Phaneroo Prod — studio de production cinématographique bilingue à Moncton, NB. Films de marque, photographie éditoriale, drone aérien au Canada Atlantique. Notre approche, nos valeurs, notre équipe."
          : "Phaneroo Prod — bilingual cinematic production studio in Moncton, NB. Brand films, editorial photography, drone aerial across Atlantic Canada. Our approach, values and team."}
        path="/studio"
        lang={lang}
        schema={schema}
      />
      <About />
      <Testimonials />
      <CtaBand />
    </main>
  );
}
